// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__178Yb","boxTitle":"Qualiphy_boxTitle__3OPV1","box":"Qualiphy_box__12gXI","toggleWrap":"Qualiphy_toggleWrap__3samw"};